import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InnerLocation } from '../types/InnerLocation';
import { Address } from '../interfaces/address';
import { WorkingHours } from '../types/WorkingHours';

@Injectable({
  providedIn: 'root',
})
export class InnerLocationService {
  private innerLocationSubject = new BehaviorSubject<InnerLocation>(this.getDefaultInnerLocation());

  innerLocation$ = this.innerLocationSubject.asObservable();

  resetInnerLocationData(): void {
    this.innerLocationSubject.next(this.getDefaultInnerLocation());
  }

  private getDefaultInnerLocation(): InnerLocation {
    return {
      name: '',
      address: {
        id: '',
        streetNumber: '',
        street: '',
        city: '',
        state: '',
        country: '',
        postalCode: '',
        latitude: 0,
        longitude: 0,
        title: '',
        iso3: '',
        timezone: '',
        note: '',
      },
      gates: [],
      workingHoursMonday: this.getDefaultWorkingHours(),
      workingHoursTuesday: this.getDefaultWorkingHours(),
      workingHoursWednesday: this.getDefaultWorkingHours(),
      workingHoursThursday: this.getDefaultWorkingHours(),
      workingHoursFriday: this.getDefaultWorkingHours(),
      workingHoursSaturday: this.getDefaultWorkingHours(),
      workingHoursSunday: this.getDefaultWorkingHours(),
    };
  }

  updateInnerLocationData(data: InnerLocation): void {
    this.innerLocationSubject.next(data);
  }

  private getDefaultWorkingHours(): WorkingHours {
    return {
      startHour: 0,
      startMinute: 0,
      endHour: 0,
      endMinute: 0,
      isAvailable: false,
    };
  }

  updateNameAndAddress(name: string, address: Address): void {
    const currentValue = this.innerLocationSubject.value;
    this.innerLocationSubject.next({ ...currentValue, name, address });
  }

  updateWorkingHours(workingHours: WorkingHours): void {
    const currentValue = this.innerLocationSubject.value;
    this.innerLocationSubject.next({
      ...currentValue,
      workingHoursMonday: workingHours,
      workingHoursTuesday: workingHours,
      workingHoursWednesday: workingHours,
      workingHoursThursday: workingHours,
      workingHoursFriday: workingHours,
      workingHoursSaturday: workingHours,
      workingHoursSunday: workingHours,
    });
  }

  updateGates(gates: { id: string; name: string }[]): void {
    const currentValue = this.innerLocationSubject.value;
    this.innerLocationSubject.next({ ...currentValue, gates });
  }
}
